/* componentName: wmx-cloudsaver
 *  React JS Component
 * =====================
 * 
 * Author: Farhadur Rahim
 * Version: 1.0.0
 * @Licence: http://codecanyon.net/wiki/support/legal-terms/licensing-terms/
 */
import React, { Component } from 'react';
import {addClient} from './utils/importClient';
import { DriveButton, DropboxButton } from './ui-element/CloudButton';
import './style.css';

class wmxCloudSaver extends Component {

    /**
     * lifecycle method after all the elements of the 
     * page is rendered correctly, this method is called.
     */
    componentDidMount() {

        // Declare dropBoxApi and assign dropboxapi props value
        const dropBoxApi = this.props.dropboxapi; 

        // check whether enabled drive button
        if( this.props.isdrive )
            addClient('https://apis.google.com/js/platform.js');
        
        // check whether enabled dropbox button
        if( this.props.isdropbox && dropBoxApi)
            addClient('https://www.dropbox.com/static/api/2/dropins.js', 'dropbox', dropBoxApi);
    }

    render() {
        return (
            <React.StrictMode>
                <div className="wmx-cloudsaver">
                    {/* Render Google Drive save button ui component */}
                    <DriveButton enable={this.props.isdrive ? true : false} file={this.props.file} filename={this.props.filename} sitename={this.props.sitename} />
                    {/* Render Dropbox save button ui component */}
                    <DropboxButton enable={this.props.isdropbox ? true : false} file={this.props.file}/>
                </div>
            </React.StrictMode>
        );
    }
}

export default wmxCloudSaver;